import React from "react";
import { useLang } from "@/i18n";
import { Warning } from "@phosphor-icons/react";

export function VisitWarningDialog({ warnings, onCancel, onProceed }) {
  const { t } = useLang();
  if (!warnings || !warnings.length) return null;
  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-end sm:items-center justify-center p-4" data-testid="visit-warning-dialog">
      <div className="w-full max-w-md rounded-2xl bg-white p-5 space-y-4">
        <div className="flex items-center gap-2 text-amber-600">
          <Warning size={24} weight="fill" />
          <h3 className="font-head font-bold text-lg">{t("please_check")}</h3>
        </div>
        <ul className="space-y-2">
          {warnings.map((w, i) => (
            <li key={i} className="text-sm text-slate-700 flex gap-2"><span className="text-amber-500">•</span>{w}</li>
          ))}
        </ul>
        <div className="flex gap-2">
          <button onClick={onCancel} data-testid="warn-check-change" className="flex-1 min-h-[48px] rounded-lg border border-slate-300 font-semibold text-slate-700">{t("check_and_change")}</button>
          <button onClick={onProceed} data-testid="warn-save-anyway" className="flex-1 min-h-[48px] rounded-lg bg-amber-500 text-white font-semibold">{t("save_anyway")}</button>
        </div>
      </div>
    </div>
  );
}
